import React from 'react';
import './FactoringSystem.scss';
import { Divider } from 'antd';
import imgSceneOne from '../../assets/defend_Images/defend_1.png';
import imgSceneTwo from '../../assets/defend_Images/defend_2.png';
import imgSceneThree from '../../assets/defend_Images/defend_3.png';
import imgSceneFour from '../../assets/defend_Images/defend_4.png';
import imaCharacteristic from '../../assets/defend_Images/defend_5.png';
import imaInterface from '../../assets/defend_Images/defend_6.png';
import imaFramework from '../../assets/defend_Images/3.png';
import technologyImgOne from '../../assets/defend_Images/defend_7.png';
import technologyImgTwo from '../../assets/defend_Images/defend_8.png';
import technologyImgThree from '../../assets/defend_Images/defend_9.png';
import technologyImgFour from '../../assets/defend_Images/defend_10.png';
import angryLittleGirl from '..//../assets/angryLittleGirl.png';

const sceneList = [
  { img: imgSceneOne, text: '追索/无追索保理' },
  { img: imgSceneTwo, text: '单笔/池保理' },
  { img: imgSceneThree, text: '正向/反向保理' },
  { img: imgSceneFour, text: '融资/非融资保理' },
];
const characteristicList = [
  {
    id: 1,
    title: '多端协作的线上一体化运作',
    word: '多端协作的线上一体化高效运作，改变传统的线下低效保理运营管理，助力企业智能信息化高效运营',
  },
  {
    id: 2,
    title: '灵活的模板配置',
    word: '可以根据核心企业自定义配置审批模板、合同模板、数据模板等信息',
  },
  {
    id: 3,
    title: '智能票据综合管理',
    word: '发票、应收账款信息可在线直接导入，也可直接对接核心企业ERP系统，可识别发票、验证发票真伪等',
  },
  {
    id: 4,
    title: '一键中登登记及查询',
    word: '在线进行中登登记，方便快捷，同时可查询应收账款登记信息、判断发票是否重复登记',
  },
  {
    id: 5,
    title: '全流程业务管理',
    word: '系统支持贷前、贷中、贷后全流程风控管理，高效验证有效客户，帮助业务人员进行决策',
  },
  {
    id: 6,
    title: '个性定制化开发',
    word: '挚云提供需求设计、技术开发、运营等服务，可根据企业实际业务流程及使用习惯定制化开发',
  },
];
const technologyList = [
  {
    id: 1,
    title: '应用安全',
    img: technologyImgOne,
    word: '采用(springbootadmin)架构对应用进行监听,如有异常可以及时的通过邮件等方式通知管理员',
  },
  {
    id: 2,
    title: '网络安全',
    img: technologyImgTwo,
    word: '前端通过密钥去申请契约,保证同一份契约只能同一个客户端使用',
  },
  {
    id: 3,
    title: '数据安全',
    img: technologyImgThree,
    word: '服务端与客户端数据传输时对数据进行加密处理,保障有效信息安全性。',
  },
  {
    id: 4,
    title: '管理安全',
    img: technologyImgFour,
    word: '设计完整的菜单权限与数据权限机制,主要采用oauth2的方式,对每一个业务模块与接口作权限管理。',
  },
];
const factoringSoftwareIntroductionText =
  '挚云数科深耕金融行业，专业提供金融、保理系统解决方案。系统支持正向、反向、融资、非融资等多种保理业务模式，从融资申请到审批、放款、保后等全链条打通，实现业务透明化，审核有效化，实现线上协同办公，降低人工成功增加效率；系统包含保理端、企业端两个端口，有效将保理机构和融资方链接起来，快速解决上游企业融资难问题。系统数据加密管理，客户数据防丢失，对接大数据征信系统，全流程智能风控管理，降低风险。';
const FactoringSystem = () => {
  return (
    <div className="factoring">
      <div className="factoring-software">
        <div className="factoring-title-weight">
          <div className="title-ch">保理系统软件介绍</div>
          <div className="title-en">
            INTRODUCTION TO FACTORING SYSTEM SOFTWARE
          </div>
          <div className="horizontal-line" />
        </div>
        <div className="factoring-software-introduction">
          <div className="factoring-software-introduction-img">
            <img src={angryLittleGirl} alt="" />
          </div>
          <div className="factoring-software-introduction-text">
            {factoringSoftwareIntroductionText}
          </div>
        </div>
      </div>
      <div className="factoring-software">
        <div className="factoring-title-weight">
          <div className="title-ch">适用场景</div>
          <div className="title-en">APPLICABLE SCENARIOS</div>
          <div className="horizontal-line" />
        </div>
        <div className="scene">
          {sceneList.map((item) => {
            return (
              <dl key={item.img}>
                <dt>
                  <img src={item.img} alt="" />
                </dt>
                <dd>{item.text}</dd>
              </dl>
            );
          })}
        </div>
      </div>
      <div className="factoring-characteristic">
        <div className="operate_highlights">
          <div className="factoring-title-weight">
            <div className="title-ch">系统特点</div>
            <div className="title-en">SYSTEM CHARACTERISTICS</div>
            <div className="horizontal-line" />
          </div>
          <div className="operate-img">
            <img src={imaCharacteristic} alt="" />
          </div>
          {characteristicList.map((item) => {
            return (
              <div key={item.id} className="operate">
                <div className="operate-title">{item.title}</div>
                <div className="operate-word">{item.word}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="factoring-software">
        <div className="factoring-title-weight">
          <div className="title-ch">系统构架</div>
          <div className="title-en">ARCHITECTURE</div>
          <div className="horizontal-line" />
        </div>
        <div className="framework">
          <img src={imaFramework} alt="" />
        </div>
      </div>
      <div className="factoring-software">
        <div className="factoring-title-weight">
          <div className="title-ch">配套接口</div>
          <div className="title-en">SUPPORTING INTERFACE</div>
          <div className="horizontal-line" />
        </div>
        <div className="interface">
          <img src={imaInterface} alt="" />
        </div>
      </div>
      <div className="factoring-software">
        <div className="factoring-title-weight">
          <div className="title-ch">技术安全</div>
          <div className="title-en">TECHNICAL SECURITY</div>
          <div className="horizontal-line" />
        </div>
        <div className="technology">
          {technologyList.map((item) => {
            return (
              <dl key={item.id} className="technology-dl">
                <dt className="technology-dt">
                  <img src={item.img} alt="" />
                </dt>
                <div className="technology-text">
                  <dd className="technology-title">{item.title}</dd>
                  <Divider />
                  <dd className="technology-word">{item.word}</dd>
                </div>
              </dl>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FactoringSystem;
